import React from "react";
import { dashboardSummary } from "../../../Assets";

const DashboardFeatureDetails = ({ enrollmentSummaryData }) => {
  const {
    gmc_premium,
    gmc_suminsured,
    parents_premium,
    parents_suminsured,
    topup_premium,
    topup_suminsured,
    myself,
  } = enrollmentSummaryData?.data || {};
  return (
    <div className="dashboard-feature-details-main-cover">
      <div className="dashboard-feature-detail-box">
        {/* <img src={dashboardSummary}></img> */}
        {/* <h5 className="feature-header-title">Enrollment Summary</h5> */}

        <div className="dashboard-feature-inner-details-cover-wrapper">
          {(gmc_suminsured || parents_suminsured || topup_suminsured) && (
            <div className="dashboard-feature-inner-box">
              <div className="dashboard-feature-inner-title">
                <h5>Group Sum Insured</h5>
                <span>(₹)</span>
              </div>
              <div className="dashboard-feature-details-box">
                <ul>
                  {gmc_suminsured && (
                    <li>
                      Health Insurance
                      <span>{gmc_suminsured}</span>
                    </li>
                  )}
                  {parents_suminsured && (
                    <li>
                      Parental SI
                      <span>{parents_suminsured}</span>
                    </li>
                  )}
                  {topup_suminsured && (
                    <li>
                      GHI Topup SI
                      <span>{topup_suminsured}</span>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          )}

          {(gmc_premium || topup_premium || parents_premium) && (
            <div className="dashboard-feature-inner-box">
              <div className="dashboard-feature-inner-title">
                <h5>Premium</h5>
                <span>(₹)</span>
              </div>
              <div className="dashboard-feature-details-box">
                <ul>
                  {gmc_premium && (
                    <li>
                      + Health Insurance
                      <span>{gmc_premium}</span>
                    </li>
                  )}
                  {topup_premium && (
                    <li>
                      + GHI Top UP
                      <span>{topup_premium}</span>
                    </li>
                  )}
                  {parents_premium && (
                    <li>
                      GHI Parent
                      <span>{parents_premium}</span>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardFeatureDetails;
